import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

const TableLoadingComponent = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 400,
                background: isDarkMode 
                    ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' 
                    : 'linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%)',
                borderRadius: 2,
                border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.06)',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: isDarkMode
                        ? 'radial-gradient(circle at 50% 50%, rgba(100, 181, 246, 0.08) 0%, transparent 70%)'
                        : 'radial-gradient(circle at 50% 50%, rgba(3, 100, 255, 0.03) 0%, transparent 70%)',
                    animation: 'pulse 3s ease-in-out infinite',
                },
                '@keyframes pulse': {
                    '0%, 100%': { opacity: 0.3 },
                    '50%': { opacity: 0.1 }
                }
            }}
        >
            {/* Spinner Principal */}
            <Box
                sx={{
                    position: 'relative',
                    mb: 3
                }}
            >
                <CircularProgress
                    size={60}
                    thickness={4}
                    sx={{
                        color: isDarkMode ? '#64B5F6' : '#0364FF',
                        animation: 'spin 2s linear infinite',
                        filter: isDarkMode 
                            ? 'drop-shadow(0 0 10px rgba(100, 181, 246, 0.3))' 
                            : 'drop-shadow(0 0 10px rgba(3, 100, 255, 0.3))',
                        '@keyframes spin': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' }
                        }
                    }}
                />
                <CircularProgress
                    size={40}
                    thickness={6}
                    sx={{
                        color: isDarkMode ? '#42A5F5' : '#0247B5',
                        position: 'absolute',
                        top: 10,
                        left: 10,
                        animation: 'spinReverse 1.5s linear infinite',
                        '@keyframes spinReverse': {
                            '0%': { transform: 'rotate(360deg)' },
                            '100%': { transform: 'rotate(0deg)' }
                        }
                    }}
                    variant="determinate"
                    value={75}
                />
            </Box>

            {/* Texto de carga */}
            <Typography
                sx={{
                    color: isDarkMode ? '#e0e0e0' : '#374151',
                    fontSize: 16,
                    fontWeight: 500,
                    mb: 1,
                    background: isDarkMode 
                        ? 'linear-gradient(135deg, #64B5F6 0%, #42A5F5 100%)' 
                        : 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}
            >
                Cargando datos...
            </Typography>

            <Typography
                sx={{
                    color: isDarkMode ? '#b0bec5' : '#6b7280',
                    fontSize: 14,
                    fontWeight: 400,
                    opacity: 0.8
                }}
            >
                Por favor espera un momento
            </Typography>

            {/* Puntos animados */}
            <Box
                sx={{
                    display: 'flex',
                    gap: 0.5,
                    mt: 2
                }}
            >
                {[0, 1, 2].map((index) => (
                    <Box
                        key={index}
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor: isDarkMode ? '#64B5F6' : '#0364FF',
                            animation: `bounce ${1.4}s ease-in-out infinite`,
                            animationDelay: `${index * 0.16}s`,
                            '@keyframes bounce': {
                                '0%, 80%, 100%': {
                                    transform: 'scale(0)',
                                    opacity: 0.5
                                },
                                '40%': {
                                    transform: 'scale(1)',
                                    opacity: 1
                                }
                            }
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};
export default TableLoadingComponent;
